import { useNavigate } from 'react-router-dom';
import RedirectButton from '../../components/Button/RedirectButton';
import { useContext } from 'react';
import CookiesBanner from '../../components/CookiesBanner';

interface RedirectSignUpProps {
  context: any;
}

export default function RedirectSignUp({ context }: RedirectSignUpProps) {
  const navigate = useNavigate();
  const { originDomainForm } = useContext<any>(context);

  function handleGoToSignUp() {
    const url =
      originDomainForm === 'signin'
        ? '/signup/criar-conta'
        : originDomainForm === 'sbt/signin'
          ? '/sbt/signup/criar-conta'
          : '/videos/signup/criar-conta';
    navigate(url);
  }

  return (
    <div className="card__footer">
      <div className="card__footer-actions">
        <RedirectButton
          name="Não tem uma Conta SBT? Crie agora"
          onClick={handleGoToSignUp}
        />

        <p
          className="account-detail"
          onClick={() => {
            console.log('TODO');
          }}
        >
          Pra que ter uma Conta SBT?
        </p>
      </div>
      <CookiesBanner />
    </div>
  );
}
